import React from 'react';
import { ChatSidePanelEmptyText } from './ChatSidePanelCard';

export default function ChatSidePanelSection({
  title = '',
  titleClassName = 'csp-sub',
  className = 'csp-subsec',
  contentClassName = '',
  isEmpty = false,
  emptyText = '',
  children = null,
}) {
  return (
    <div className={className}>
      {title ? <div className={titleClassName}>{title}</div> : null}
      {isEmpty ? (
        <ChatSidePanelEmptyText>{emptyText}</ChatSidePanelEmptyText>
      ) : contentClassName ? (
        <div className={contentClassName}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
}
